// Actions realted to my stuff, my items, ecc
import { makePaginatedItemsActions } from './items'

export const GET_OWNED_ITEMS = 'GET_OWNED_ITEMS'
export const [
  loadOwnedItems,
  loadMoreOwnedItems,
  unloadOwnedItems,
  putOwnedItemsInCache,
] = makePaginatedItemsActions(GET_OWNED_ITEMS)

export const GET_WANTED_ITEMS = 'GET_WANTED_ITEMS'
export const [
  loadWantedItems,
  loadMoreWantedItems,
  unloadWantedItems,
  putWantedItemsInCache,
] = makePaginatedItemsActions(GET_WANTED_ITEMS)

export const GET_INTEREST_ITEMS = 'GET_INTEREST_ITEMS'
export const [
  loadInterestItems,
  loadMoreInterestItems,
  unloadInterestItems,
] = makePaginatedItemsActions(GET_INTEREST_ITEMS)

export const GET_ITEMS_I_CAN_GET = 'GET_ITEMS_I_CAN_GET'
export const [
  loadItemsICanGet,
  loadMoreItemsICanGet,
  unloadItemsICanGet,
  putItemsICanGetInCache,
] = makePaginatedItemsActions(GET_ITEMS_I_CAN_GET)

export const REFRESH_LOGGED_USER_COUNTS = 'REFRESH_LOGGED_USER_COUNTS'
// refreshUserCounts([ 'newSwaps' ]) or for all refreshUserCounts([ 'newSwaps' ])
export const refreshUserCounts = countsToRefresh => ({
  type: REFRESH_LOGGED_USER_COUNTS,
})

export const LOGGED_USER_COUNTS_LOADING = 'LOGGED_USER_COUNTS_LOADING'
export const LOGGED_USER_COUNTS_FAILURE = 'LOGGED_USER_COUNTS_FAILURE'
export const LOGGED_USER_COUNTS_SUCCESS = 'LOGGED_USER_COUNTS_SUCCESS'



// WEBPACK FOOTER //
// ./src/actions/me.js